export default __webpack_public_path__ + "static/media/14.dd632af4.jpg";